import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

import fetchedReducer from './fetchedReducer';
import uiReducer from './uiReducer';
import uploadsReducer from './uploadsReducer';
import { store } from '../App';
import saveApplication from '../components/SaveApplication/SaveApplication.reducer';
import additionalGuarantorReducer from '../containers/AdditionalGuarantor/AdditionalGuarantor.reducer';
import automatedLendingDecisionReducer from '../containers/AutomatedLendingDecision/AutomatedLendingDecision.reducer';
import exitPollReducer from '../containers/AutomatedLendingDecision/ExitPoll/ExitPoll.reducer';
import modalsReducer from '../containers/Modals/Modals.reducer';
import OffersReducer from '../containers/Offers/offers/OffersReducer';
import navigation from '../containers/Routes/Navigation.reducer';
import TradingHistoryReducer from '../containers/TradingHistoryV2/TradingHistory.reducer';
import lendingAPI from '../lendingAPI/lendingAPI.reducer';

const rootReducer = combineReducers({
    fetched: fetchedReducer,
    form: reduxFormReducer,
    ui: uiReducer,
    uploads: uploadsReducer,
    additionalGuarantor: additionalGuarantorReducer,
    navigationContext: navigation,
    modals: modalsReducer,
    automatedLendingDecision: automatedLendingDecisionReducer,
    exitPoll: exitPollReducer,
    lendingAPI,
    saveApplication,
    // @ts-ignore
    offers: OffersReducer,
    tradingHistory: TradingHistoryReducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default rootReducer;
